import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  add_interview_kit_topic_question_mentor_action,
  delete_interview_kit_topic_mentor_action,
  delete_interview_kit_topic_question_mentor_action,
  get_interview_kit_by_id_data_action,
  update_interview_kit_action,
  update_interview_kit_topic_mentor_action,
  update_interview_kit_topic_question_mentor_action,
} from "../../../redux/_actions/mentor";
import { useNavigate, useParams } from "react-router-dom";
import { showWarningMessage } from "../../../_uiComponents/ShowMessageSnack";
function useCreateAssessmentKitTopic(props) {
  const [assessmentKit, setAssessmentKit] = useState({});
  const [assessmentKitTopic, setAssessmentKitTopic] = useState({});
  const [createQuestion, setCreateQuestion] = useState(false);

  const [selectedQuestion, setSelectedQuestion] = useState({});
  const [suggestedQuestions, setSuggestedQuestions] = useState([]);
  const [searchSuggestedQuestion, setSearchSuggestedQuestion] = useState(false);
  const [suggestedQuestionsSelected, setSuggestedQuestionsSelected] = useState(
    []
  );
  const [editTopic, setEditTopic] = useState(null);
  const [isEditTopic, setIsEditTopic] = useState(false);

  const [loading, setLoading] = useState(false);

  const { interviewKitData } = useSelector(
    (state) => state.get_interview_kit_by_id_data_reducer
  );
  const { getQuestionsBank } = useSelector(
    (state) => state.get_questions_bank_reducer
  );
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    let assessmentId = params?.assessmentId;
    if (assessmentId) callApi(assessmentId);
  }, [params]);

  useEffect(() => {
    if (interviewKitData?.data) {
      let data = interviewKitData?.data;

      let topicId = params?.topicId;

      if (topicId) {
        let topic =
          data?.topics &&
          Array.isArray(data?.topics) &&
          data.topics.filter((item) => item.id == topicId);
        setAssessmentKitTopic(topic[0]);
      }
      setAssessmentKit(data);
    }
  }, [interviewKitData]);

  const callApi = async (id) => {
    setLoading(true);
    await dispatch(get_interview_kit_by_id_data_action(id));
    setLoading(false);
  };
  const calculateAssessmentKitEstimatedTime = () => {
    let total_time = 0;
    assessmentKitTopic?.questions &&
      Array.isArray(assessmentKitTopic.questions) &&
      assessmentKitTopic.questions.forEach(
        (element) =>
          (total_time = parseInt(element?.time_to_answer) + total_time)
      );

    return total_time;
  };

  const onBackClick = () => navigate(-1);

  const onTopicTitleChange = async (e) => {
    let data = assessmentKitTopic;
    data["topic_name"] = e.target.value;
    setAssessmentKitTopic(data);
    if (assessmentKitTopic?.id) {
      await dispatch(
        update_interview_kit_topic_mentor_action(
          { name: e.target.value },
          assessmentKitTopic?.id
        )
      );
    }
  };

  const onDeleteTopicClick = async () => {
    if (assessmentKitTopic?.id) {
      await dispatch(
        delete_interview_kit_topic_mentor_action(assessmentKitTopic?.id)
      );
      navigate(-1);
    }
  };

  const onSelectedQustionChange = async (e) => {
    let data = selectedQuestion;
    let value = e.target.value;
    let name = e.target.name;
    if (name === "questions_rank") name = "rank";
    if (name === "skills") {
      let skill = [];
      skill[0] = e.target.value;
      setSelectedQuestion({
        ...selectedQuestion,
        skills: skill,
        skill_names: skill,
      });
      return;
    } else data[name] = value;
    setSelectedQuestion(data);
  };

  const onSelectedQuestionSaveClick = async () => {
    let data = {};
    data["question"] = selectedQuestion?.question;
    data["rank"] = selectedQuestion?.rank;
    data["time_to_answer"] = selectedQuestion?.time_to_answer;
    data["is_public"] = true;
    data["skills"] = selectedQuestion?.skills;
    data["difficulty_level"] = selectedQuestion?.difficulty_level;
    if (
      data.question === "" ||
      data.question === null ||
      data.question === undefined ||
      data.time_to_answer === null ||
      data.time_to_answer === undefined || 
      data.difficulty_level === null ||
      data.difficulty_level === "" ||
      data.difficulty_level === undefined ||
      // data.rank === null ||
      // data.rank === "" ||
      data.time_to_answer === "" ||
      data.time_to_answer === null ||
      data.time_to_answer === undefined ||
      data.skills && data.skills.length === 0
    ) {
      showWarningMessage("Please enter value in question fields.");
    } else {
      if (selectedQuestion?.id) {
        data["rank"] = parseInt(selectedQuestion?.rank);
        data["time_to_answer"] = parseInt(selectedQuestion?.time_to_answer);
        await dispatch(
          update_interview_kit_topic_question_mentor_action(
            data,
            selectedQuestion?.id
          )
        );
        window.location.reload();
        setCreateQuestion(false);
        setSelectedQuestion({});
      } else {
        if (assessmentKitTopic?.id) {
          data["interview_kit_id"] = assessmentKit?.id;
          data["topic"] = assessmentKitTopic?.id;
          let formData = [];
          formData.push(data);
          await dispatch(
            add_interview_kit_topic_question_mentor_action(formData)
          );
          window.location.reload();
          setCreateQuestion(false);
          setSelectedQuestion({});
        } else {
          if (assessmentKitTopic?.questions) {
            let specificArrayInObject = assessmentKitTopic.questions.slice();
            specificArrayInObject.push({ ...data });
            const newObj = {
              ...assessmentKitTopic,
              ["questions"]: specificArrayInObject,
            };
            setAssessmentKitTopic(newObj);
          } else {
            let formData = assessmentKitTopic;
            formData["questions"] = [];
            formData["questions"].push(data);
            setAssessmentKitTopic(formData);
            onSaveNewTopicClick();
          }
          setCreateQuestion(false);
          setSelectedQuestion({});
        }
      }
    }
  };

  const onAddNewQuestionClick = (question) => {
    setIsEditTopic(false);
    setEditTopic(null);
    if (question) {
      let data = question;
      data["skills"] = data["skill_names"];
      setSelectedQuestion(data);
    } else {
      setCreateQuestion(true);
    }
  };

  const onSaveNewTopicClick = async () => {
    if (assessmentKitTopic?.id === undefined) {
      let data = [];
      data[0] = assessmentKitTopic;
      await dispatch(
        update_interview_kit_action({ topics: data }, assessmentKit?.id)
      );
    }
    navigate(-1);
  };

  // const onCreateFirstTopic = async () => {
  //   if (assessmentKitTopic?.id === undefined) {
  //     let data = [];
  //     data[0] = assessmentKitTopic;
  //     await dispatch(
  //       update_interview_kit_action({ topics: data }, assessmentKit?.id)
  //     );
  //   }
  //   navigate(-1);
  // };

  const onDeleteQuestionClick = async (question, questionIndex) => {
    if (question?.id) {
      await dispatch(
        delete_interview_kit_topic_question_mentor_action(question?.id)
      );
    }
    let specificArrayInObject = assessmentKitTopic.questions.slice();
    specificArrayInObject.splice(questionIndex, 1);
    const newObj = {
      ...assessmentKitTopic,
      ["questions"]: specificArrayInObject,
    };
    setAssessmentKitTopic(newObj);
  };

  // useEffect(() => {
  //   if (interviewKitData?.data) {
  //     getSuggestedQuestions(interviewKitData?.data?.topics[0]?.name);
  //   }
  // }, [interviewKitData]);

  useEffect(() => {
    if (getQuestionsBank?.data) {
      setSuggestedQuestions(getQuestionsBank?.data);
    }
  }, [getQuestionsBank]);

  const getSuggestedQuestions = async (topicName) => {
    const formData = {
      index: "question_bank",
    };
    if (searchSuggestedQuestion) {
      formData["search"] = topicName;
    } else {
      formData["topic_name"] = topicName;
    }
    // const data = await dispatch(get_questions_bank_action(formData));
  };

  const searchSuggestedQuestionHandler = (e) => {
    setSearchSuggestedQuestion(true);
    getSuggestedQuestions(e.target.value);
  };

  const onSuggestedQuestionSelect = (e, item) => {
    if (e.target.checked) {
      setSuggestedQuestionsSelected([...suggestedQuestionsSelected, item]);
    } else {
      setSuggestedQuestionsSelected(
        suggestedQuestionsSelected.filter((question) => question !== item)
      );
    }
  };

  const addSuggestedQuestion = async () => {
    await dispatch(
      add_interview_kit_topic_question_mentor_action(suggestedQuestionsSelected)
    );
  };

  const cancelUpdateEditTopic = () => {
    setCreateQuestion(false);
    setSelectedQuestion({});
  };
  return {
    assessmentKit,
    loading,
    assessmentKitTopic,
    createQuestion,
    selectedQuestion,
    suggestedQuestions,
    searchSuggestedQuestion,
    suggestedQuestionsSelected,

    onBackClick,
    calculateAssessmentKitEstimatedTime,
    onDeleteTopicClick,
    onTopicTitleChange,
    onSelectedQustionChange,
    onSelectedQuestionSaveClick,
    onAddNewQuestionClick,
    onDeleteQuestionClick,
    onSaveNewTopicClick,
    searchSuggestedQuestionHandler,
    onSuggestedQuestionSelect,
    addSuggestedQuestion,
    // onEditTopicClick,
    // onUpdateField,
    // updateEditTopic,
    cancelUpdateEditTopic,
  };
}

export default useCreateAssessmentKitTopic;
